import { FC } from 'react'
import { ReviewCustomer } from './ReviewCustomer'
import { ReviewPricing } from './ReviewPricing'
import { StepComponentProps, WatchtowerSteps } from './steps.types'

export const STEP_COMPONENTS: Partial<{
  [K in WatchtowerSteps['step']]: FC<StepComponentProps>
}> = {
  REVIEW_CUSTOMER: ReviewCustomer,
  REVIEW_PRICING: ReviewPricing
}

export type { WatchtowerSteps }
